import { css } from "vite-css-in-js"
import { computed } from "vue"
import { defineComponent, type ReactiveComponent } from "vue-utils"
import { useIncidentHandler } from "../../IncidentLogHandler"
import AdditionalIncidentLocations from "./AdditionalIncidentLocations"
import InitialIncidentLocation from "./InitialIncidentLocation"

const sectionStyles = css`
	border: solid thin rgba(0, 0, 0, 0.25);
	background-color: rgba(255, 255, 255, 0.75);
	box-shadow: 0.25rem 0.25rem 0.25rem #a0a0a0;
	border-radius: 0.35rem;
	padding: 0.75rem;

	& > h5 {
		font-size: 1.1rem;
	}
`

const IncidentLocation: ReactiveComponent = () => {
	const handler = useIncidentHandler()
	const position = computed(() => handler.incident.positions.at(0))

	return () => (
		<div class="flex flex-col spacing-4">
			<section class={sectionStyles}>
				<h5>Initial Location</h5>
				<hr />
				<InitialIncidentLocation />
			</section>
			{Number.isFinite(position.value?.position.latitude) && Number.isFinite(position.value?.position.longitude) && (
				<section class={sectionStyles}>
					<h5>Additional Locations</h5>
					<hr />
					<AdditionalIncidentLocations />
				</section>
			)}
		</div>
	)
}

export default defineComponent(IncidentLocation)
